import React from 'react';
import styled, { keyframes } from 'styled-components';

interface InfoNoticeCardProps {
  title: string;
  content: string;
  timestamp?: string;
}

const InfoNoticeCard: React.FC<InfoNoticeCardProps> = ({ title, content, timestamp = 'just now' }) => {
  return (
    <StyledWrapper>
      <div className="card">
        <div className="img info-icon" />
        <div className="textBox">
          <div className="textContent">
            <p className="h1">{title}</p>
            <span className="span">{timestamp}</span>
          </div>
          <p className="p">{content}</p>
        </div>
      </div>
    </StyledWrapper>
  );
}

const fadeInSlide = keyframes`
  0% {
    transform: translateX(100%) scale(0.8);
    opacity: 0;
  }
  100% {
    transform: translateX(0) scale(1);
    opacity: 1;
  }
`;

const StyledWrapper = styled.div`
  .card {
    width: 100%;
    height: 80px;
    background: linear-gradient(135deg, #2196F3, #1976D2);
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: left;
    backdrop-filter: blur(10px);
    transition: 0.3s ease-in-out;
    animation: ${fadeInSlide} 0.5s ease-out;
    box-shadow: 0 4px 15px rgba(33, 150, 243, 0.3);
    border: 1px solid rgba(255, 255, 255, 0.2);
  }

  .card:hover {
    cursor: pointer;
    transform: translateY(-2px) scale(1.02);
    box-shadow: 0 6px 20px rgba(33, 150, 243, 0.4);
  }

  .img {
    width: 50px;
    height: 50px;
    margin-left: 15px;
    border-radius: 12px;
    transition: 0.3s ease-in-out;
  }

  .info-icon {
    background: linear-gradient(135deg, #42A5F5, #2196F3);
    position: relative;
  }

  .info-icon::after {
    content: 'ℹ';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 24px;
    font-weight: bold;
  }

  .textBox {
    width: calc(100% - 90px);
    margin-left: 15px;
    color: white;
    font-family: 'Poppins', sans-serif;
  }

  .textContent {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 4px;
  }

  .span {
    font-size: 11px;
    opacity: 0.8;
  }

  .h1 {
    font-size: 16px;
    font-weight: 600;
    margin: 0;
  }

  .p {
    font-size: 13px;
    font-weight: 400;
    margin: 0;
    opacity: 0.9;
    line-height: 1.3;
  }
`;

export default InfoNoticeCard;
